import { FC } from "react";
import { cn, Input } from "@racoon/ui";
import { Namespace, useT } from "@racoon/i18n";
import type { WindowForm } from "../model/types";

/** Digits only, the colon added: "0930" → "09:30". */
const maskTime = (raw: string) => {
  const digits = raw.replace(/\D/g, "").slice(0, 4);
  return digits.length <= 2 ? digits : `${digits.slice(0, 2)}:${digits.slice(2)}`;
};

type Props = {
  window: WindowForm;
  onChange: (window: WindowForm) => void;
  readOnly?: boolean;
  dashClassName?: string;
};

/** A pickup window as "06:00 - 12:00" (Figma 22793:51107). */
export const WindowFields: FC<Props> = ({ window, onChange, readOnly, dashClassName }) => {
  const t = useT();
  const field = (key: keyof WindowForm) => (
    <Input
      aria-label={t(Namespace.PickupLocation, key === "from" ? "modal.start" : "modal.end")}
      size="sm"
      inputMode="numeric"
      maxLength={5}
      placeholder="--:--"
      value={window[key]}
      readOnly={readOnly}
      onChange={(e) => onChange({ ...window, [key]: maskTime(e.target.value) })}
      className="flex-1 border-border-primary text-center !text-sm text-text-body"
    />
  );
  return (
    <div className="flex min-w-0 flex-1 items-center gap-2">
      {field("from")}
      <span className={cn("text-sm text-text-body", dashClassName)}>-</span>
      {field("to")}
    </div>
  );
};
